import Layout from "../layouts/LayoutDefault.jsx";
import { useLocation } from "react-router-dom";
import MakeGetRequest from "../components/utils/MakeGetRequest";
import AdminView from "../components/band_page/AdminView.jsx";
import MainContainer from "../components/MainContainer.jsx";
import ProfileHero from "../components/band_page/ProfileHero.jsx";
import BasicProfileInfoCard from "../components/band_page/BasicProfileInfoCard.jsx";
import DescriptionBlock from "../components/band_page/DescriptionBlock.jsx";
import BandPostsCards from "../components/band_page/BandPostsCards.jsx";
import CommercialBanner from "../components/CommercialBanner.jsx";


const BandPage = () => {
  // Get the full pathname
  const location = useLocation();
  let pathname = location.pathname;

  // Remove trailing slash if it exists
  if (pathname.endsWith("/")) {
    pathname = pathname.slice(0, -1);
  }
  // Extract the slug after 'music/'
  const slug = pathname.split("/music/")[1];
  // Fetch Band data
  const { data: bandData } = MakeGetRequest({
    route: `get_band_profile?slug=${slug}`,
    errorCodeRedirect: 404,
  });

  const profileSettingsUrl = `/userprofile/band?slug=${slug}`;
  const bandLocation = "Strängnäs"; // Make this dynamic later
  return (
    <>
      <Layout
        title={bandData?.band.name}
        description={`${bandData?.band.name} ifrån ${bandLocation}. ${bandData?.band.description}`.substring(
          0,
          150
        )}
      >
        {bandData ? (
          <>
            {bandData.admin_view && (
              <AdminView
                settingsUrl={profileSettingsUrl}
                isVisible={bandData.band.visible}
              />
            )}
            <MainContainer noTopPadding={true}>
              <ProfileHero
                name={bandData.band.name}
                splashImage={bandData.band.image_splash}
                gigSeekers={bandData.band.gig_seekers}
                genreMain={bandData.band.genre_main}
                genreSubs={bandData.band.genre_sub}
              />
              
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mt-8">
                {/* Left Column - Profil Info, Streama & Socials */}
                <div className="lg:col-span-4 flex flex-col gap-6">
                  <BasicProfileInfoCard
                    name={bandData.band.name}
                    profileImage={bandData.band.image_profile}
                    active={bandData.band.active}
                    constalation={bandData.band.constellation_type}
                    socials={bandData.socials}
                    streamingplatfoms={bandData.streamingplatforms}
                    homepage={bandData.band.official_homepage}
                    mail={bandData.band.official_mail}
                    likes={bandData.likes}
                    followers={bandData.followers}
                  />
                </div>

                {/* Right Column - Biografi, Nyheter */}
                <div className="lg:col-span-8 flex flex-col gap-6">
                  <DescriptionBlock
                    description={bandData.band.description}
                    likes={bandData.likes}
                    followers={bandData.followers}
                  />
                  <BandPostsCards data={bandData} />
                </div>
              </div>

              <div className="mt-8">
                <CommercialBanner />
              </div>
            </MainContainer>
          </>
        ) : (
          <div>
            <h4>Bläddrar i arkiven...</h4>
          </div>
        )}
      </Layout>
    </>
  );
};

export default BandPage;
